export default "__VITE_ASSET__BjcBr9fY__"